<!-- Splash Screen -->
<div class="splash-screen" *ngIf="showSplash">
  <div class="splash-content">
    <div class="splash-logo">
      <div class="logo-text">Ruku na <span>Srce</span></div>
      <div class="loading-bar">
        <div class="loading-progress"></div>
      </div>
    </div>
  </div>
</div>

<!-- Login Screen -->
<div class="container-fluid h-100 login-screen" *ngIf="showLogin && isFormReady">
  <div class="row align-items-center justify-content-center h-100">
    <div class="col-auto">
      <div class="logo">
        Ruku na <span>Srce</span>
      </div>
      <nz-card class="login-card" [nzTitle]="'login' | translate">
        <form
          nz-form
          [formGroup]="form"
          class="login-form"
          (ngSubmit)="submitForm()"
        >
          <nz-form-item>
            <nz-form-control>
              <nz-input-group nzPrefixIcon="user">
                <input
                  type="text"
                  nz-input
                  formControlName="email"
                  [placeholder]="'email' | translate"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control>
              <nz-input-group nzPrefixIcon="lock">
                <input
                  type="password"
                  nz-input
                  formControlName="password"
                  [placeholder]="'password' | translate"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
          <button
            nz-button
            class="login-form-button login-form-margin"
            nzType="primary"
            [nzLoading]="isLoading"
          >
            {{ 'loginAction' | translate }}
          </button>
        </form>
      </nz-card>
    </div>
  </div>
</div>
